import _ from 'underscore';
import React from 'react';
import Selectable from '../common/selectable';

const SelectableList = React.createClass({

	propTypes: {
		tagName: React.PropTypes.string.isRequired,
		className: React.PropTypes.string,
		selectedClass: React.PropTypes.oneOfType([
      React.PropTypes.string,
      React.PropTypes.func
    ]).isRequired,
    itemTemplate: React.PropTypes.func.isRequired,
    items: React.PropTypes.array.isRequired,
    multiSelect: React.PropTypes.bool,
    toggleSelect: React.PropTypes.bool,
    onChange: React.PropTypes.func
	},

	getInitialState: function() {
    let lastSelected;
    let selectedItems = {};
    if(!this.props.toggleSelect 
        && !this.props.multiSelect 
        && this.props.items.length > 0) {

      lastSelected = {
        data: _.find(this.props.items, {selected: true}) || this.props.items[0],
        selected: true
      };
      selectedItems[lastSelected.data.id] = true;

    }
		return {
			lastSelected: lastSelected,
      selectedItems: selectedItems
		}
	},

  componentWillReceiveProps: function(props) {
    let hasChanges = _.some(props.items, item => this.state.selectedItems[item.id]);
    let selectedItems;

    if(hasChanges) {
      selectedItems = props.items.reduce((items, item) => {
        if(item.selected === true) {
          items[item.id] = true;
        }
        return items;
      }, {});
      this.setState({ lastSelected: null, selectedItems: selectedItems });
    }
  },

  render: function() {
  	let items = this._renderItems(this.props.items);
    return (
    	<this.props.tagName className={this.props.className}>
				{items}	    	
    	</this.props.tagName>
    );
  },

  handleItemClick: function(selectable, data, selected) {
  	if(this.props.multiSelect) {
  		this._handleMultiSelectClick(selectable, data, selected);
  	}
  	else {
  		this._handleSelectClick(selectable, data);
  	}
  },

  _handleMultiSelectClick: function(selectable, data, selected) {
    selected = selectable.toggleSelect();
    this._updateState(data, selected);
  },

  _handleSelectClick: function(selectable, data) {
  	let lastSelected = this.state.lastSelected;
  	let selected = true;
  	let changeSelect = !lastSelected || (lastSelected.data.id !== data.id);

  	if(this.props.toggleSelect || changeSelect) {
  		if(lastSelected) {
  			this.refs[lastSelected.data.id].unselect();
  		}
  		
  		if(this.props.toggleSelect) {
  			selected = selectable.toggleSelect();
  		}
  		else {
  			selectable.select();
  		}
			
      this._updateState(data, selected);
		}
	},

  _renderItems: function(items) {
  	return items.map((data, i) => {
  		let newItem = this.props.itemTemplate(data, (e) => this.handleItemClick(
        this.refs[data.id], 
        data, 
        this.refs[data.id].state.selected
      ));
      let selected; 

      if(data.selected !== undefined) {
        selected = data.selected;
      }
      else {
        selected = this.state.selectedItems[data.id] === true;
      }
      
  		return (
				<Selectable
					key={i}
          ref={data.id}
					id={data.id}
          data={data}
					selected={selected}
					selectedClass={this.props.selectedClass}
          overrideClick={true}>
					{newItem}
				</Selectable>
			);
  	});
  },

  _updateState: function(data, selected) {
    let lastSelected = this.state.lastSelected || {};
    let currentSelected = {
      data: data,
      selected: selected
    };

    if(lastSelected.data !== currentSelected.data || 
      lastSelected.selected !== currentSelected.selected) {

      this.setState({ lastSelected: currentSelected });

      if(this.props.onChange) {
        this.props.onChange(lastSelected, currentSelected);
      }
    }
  }

});

export default SelectableList;



/** WEBPACK FOOTER **
 ** ./src/js/components/common/selectable_list.js
 **/